import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import * as Sentry from '@sentry/angular';

Sentry.init({
  dsn: 'https://2bf52c3ebf785c10f8191c2b8e341622@o4510864476536832.ingest.de.sentry.io/4510864486891600',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
